import { authStore } from "../stores";

export const useAuthStore = () => authStore;
